import { useEffect, useState } from 'react';
import { FormInstance } from 'antd/lib/form';
import CloudProvider from '../../types/CloudProvider';
import DeploymentOptions from '../../types/DeploymentOptions';
import InstanceVolumeIopsValue from '../../types/InstanceVolumeIopsValue';
import InstanceVolumeType from '../../types/InstanceVolumeType';

// The IOPS config has to follow the volumeType state change itself: form
// callbacks read the state one update behind, which left the IOPS field
// hidden on the first selection of an IOPS volume type (CCX-6133).
export default function useVolumeIops(
    deploymentOptions: DeploymentOptions | undefined,
    cloudProvider: CloudProvider | undefined,
    volumeType: InstanceVolumeType | undefined,
    form: FormInstance
): InstanceVolumeIopsValue | undefined {
    const [volumeIops, setVolumeIops] = useState<
        InstanceVolumeIopsValue | undefined
    >(undefined);

    useEffect(() => {
        const vi =
            cloudProvider && volumeType?.hasIops
                ? deploymentOptions?.getVolumeIops(
                      cloudProvider,
                      volumeType.code
                  )
                : undefined;
        if (vi && !form.getFieldValue('volumeIops')) {
            form.setFieldsValue({ volumeIops: vi.default });
        }
        setVolumeIops(vi);
    }, [deploymentOptions, cloudProvider, volumeType, form]);

    return volumeIops;
}
